const LIMITE_AFIP_HARDCODED_YPF = 10000000;

const getLimiteAfip = async () => {
  return LIMITE_AFIP_HARDCODED_YPF;
};

const limiteAfip = {
  getLimiteAfip,
};

export default limiteAfip;
